app.formValidation = (function () {
  'use strict';

  let validationService = new aspnetValidation.ValidationService();

  // function initRequiredRadioButtons() {
  //   document
  //     .querySelectorAll('[data-val-requiredradio]:not(.is-initialized)')
  //     .forEach((element) => {
  //       const inputName = element.getAttribute('name');
  //       const errorMessage = element.getAttribute('data-val-requiredradio');

  //       element.form
  //         .querySelectorAll('[name="' + inputName + '"]')
  //         .forEach((radio) => {
  //           radio.setAttribute('data-val', 'true');
  //           radio.setAttribute('data-val-requiredradio', errorMessage);
  //           radio.classList.add('is-initialized');
  //         });
  //     });
  // }

  function init() {
    // Use the same `required` validation as Umbraco Forms
    // var required = function (value, element) {
    //   if (
    //     element.type.toLowerCase() === 'checkbox' ||
    //     element.type.toLowerCase() === 'radio'
    //   ) {
    //     var allCheckboxesOfThisName = element.form.querySelectorAll(
    //       "input[name='" + element.name + "']"
    //     );
    //     for (var i = 0; i < allCheckboxesOfThisName.length; i++) {
    //       if (allCheckboxesOfThisName[i].checked === true) {
    //         return true;
    //       }
    //     }
    //     return false;
    //   }
    //   return Boolean(value);
    // };

    // validationService.addProvider('requiredcb', required);
    // validationService.addProvider('required', required);

    // mustbetrue validation (checkbox)
    // validationService.addProvider('mustbetrue', (value, element, params) => {
    //   return element.checked;
    // });

    // postalcodecountrycombo validation
    // validationService.addProvider(
    //   'postalcodecountrycombo',
    //   (value, element, params) => {
    //     const countryField = element.form.querySelector(
    //       '[name="' + params.country + '"]'
    //     );

    //     if (countryField !== null) {
    //       if (countryField.value === 'NLD') {
    //         return /^[1-9]{1}[0-9]{3}\s{0,1}[a-zA-Z]{2}$/g.test(value);
    //       } else if (countryField.value === 'BEL') {
    //         return /^[1-9]{1}[0-9]{3}$/g.test(value);
    //       }
    //     }

    //     return true;
    //   }
    // );

    // requiredradio validation (radio buttons)
    // validationService.addProvider('requiredradio', (value, element, params) => {
    //   const inputName = element.getAttribute('name');
    //   const checkedOption = element.form.querySelector(
    //     '[name="' + inputName + '"]:checked'
    //   );
    //   if (checkedOption !== null) {
    //     element.form
    //       .querySelectorAll('[name="' + inputName + '"]')
    //       .forEach((radio) => {
    //         radio.classList.remove('input-validation-error');
    //         radio.classList.add('input-validation-valid');
    //       });

    //     return true;
    //   }

    //   element.form
    //     .querySelectorAll('[name="' + inputName + '"]')
    //     .forEach((radio) => {
    //       radio.classList.remove('input-validation-valid');
    //       radio.classList.add('input-validation-error');
    //     });
    //   return false;
    // });

    // initRequiredRadioButtons();

    // init client-side validation
    validationService.bootstrap();
  }

  // Expose public functions and variables
  return {
    init: init,
    // initRequiredRadioButtons: initRequiredRadioButtons,
    validationService: validationService,
  };
})();

app.formValidation.init();
